/**
 * Grill King recently viewed — localStorage rail + scroll-snap slider.
 */
(function () {
  'use strict';

  if (window.__egjRecentlyViewed) return;
  window.__egjRecentlyViewed = true;

  var KEY = 'egj-recently-viewed';
  var MAX = 12;
  var SHOW = 10;

  function read() {
    try {
      var raw = window.localStorage.getItem(KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try {
      window.localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX)));
    } catch (e) {}
  }

  function normalize(item) {
    if (!item || !item.handle || !item.url || !item.title) return null;
    return {
      handle: String(item.handle),
      url: String(item.url),
      title: String(item.title),
      image: item.image ? String(item.image) : '',
      price: item.price ? String(item.price) : '',
      compare: item.compare ? String(item.compare) : ''
    };
  }

  function remember(item) {
    var next = normalize(item);
    if (!next) return;
    var list = read().filter(function (entry) {
      return entry && entry.handle !== next.handle;
    });
    list.unshift(next);
    write(list);
  }

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function escapeAttr(value) {
    return escapeHtml(value).replace(/'/g, '&#39;');
  }

  /** Allow only http(s) or root-relative URLs — rejects javascript:/data: from localStorage. */
  function safeUrl(value) {
    var raw = String(value || '').trim();
    if (!raw) return '';
    if (raw.charAt(0) === '/' && raw.charAt(1) !== '/') return raw;
    try {
      var parsed = new URL(raw, window.location.origin);
      if (parsed.protocol === 'http:' || parsed.protocol === 'https:') return parsed.href;
    } catch (e) {}
    return '';
  }

  function safeImageUrl(value) {
    return safeUrl(value);
  }

  function slideWidth(track) {
    var item = track.querySelector('.egj-recent__item');
    if (!item) return track.clientWidth * 0.7;
    var styles = window.getComputedStyle(track);
    var gap = parseFloat(styles.columnGap || styles.gap) || 0;
    return item.getBoundingClientRect().width + gap;
  }

  function updateControls(root) {
    var track = root.querySelector('[data-egj-recent-track]');
    var prev = root.querySelector('[data-egj-recent-prev]');
    var next = root.querySelector('[data-egj-recent-next]');
    var dots = root.querySelectorAll('[data-egj-recent-dot]');
    var progress = root.querySelector('[data-egj-recent-progress]');
    if (!track) return;

    var maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
    var left = track.scrollLeft;
    var atStart = left <= 4;
    var atEnd = left >= maxScroll - 4;

    if (prev) prev.disabled = atStart;
    if (next) next.disabled = atEnd;

    if (progress && maxScroll > 0) {
      var ratio = Math.min(1, Math.max(0, left / maxScroll));
      progress.style.transform = 'scaleX(' + (0.2 + ratio * 0.8) + ')';
    } else if (progress) {
      progress.style.transform = 'scaleX(1)';
    }

    if (dots.length) {
      var step = slideWidth(track) || 1;
      var index = Math.round(left / step);
      index = Math.max(0, Math.min(dots.length - 1, index));
      dots.forEach(function (dot, i) {
        var active = i === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });
    }

    root.classList.toggle('is-at-start', atStart);
    root.classList.toggle('is-at-end', atEnd);
    root.classList.toggle('is-scrollable', maxScroll > 8);
  }

  function bindSlider(root) {
    var track = root.querySelector('[data-egj-recent-track]');
    var prev = root.querySelector('[data-egj-recent-prev]');
    var next = root.querySelector('[data-egj-recent-next]');
    var dots = root.querySelectorAll('[data-egj-recent-dot]');
    if (!track) return;

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        updateControls(root);
        ticking = false;
      });
    }

    track.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () {
      updateControls(root);
    });

    function scrollByDir(dir) {
      track.scrollBy({ left: dir * slideWidth(track), behavior: 'smooth' });
    }

    if (prev) {
      prev.addEventListener('click', function () {
        scrollByDir(-1);
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        scrollByDir(1);
      });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var index = parseInt(dot.getAttribute('data-egj-recent-dot'), 10) || 0;
        track.scrollTo({ left: index * slideWidth(track), behavior: 'smooth' });
      });
    });

    /* Pointer drag for desktop feel */
    var isDown = false;
    var startX = 0;
    var startLeft = 0;
    var moved = false;

    track.addEventListener('pointerdown', function (event) {
      if (event.pointerType === 'touch') return;
      isDown = true;
      moved = false;
      startX = event.clientX;
      startLeft = track.scrollLeft;
      track.classList.add('is-dragging');
      try {
        track.setPointerCapture(event.pointerId);
      } catch (e) {}
    });

    track.addEventListener('pointermove', function (event) {
      if (!isDown) return;
      var dx = event.clientX - startX;
      if (Math.abs(dx) > 4) moved = true;
      track.scrollLeft = startLeft - dx;
    });

    function endDrag(event) {
      if (!isDown) return;
      isDown = false;
      track.classList.remove('is-dragging');
      if (moved) {
        event.preventDefault();
      }
    }

    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);
    track.addEventListener('click', function (event) {
      if (moved) {
        event.preventDefault();
        event.stopPropagation();
        moved = false;
      }
    }, true);

    updateControls(root);
  }

  function render(root) {
    if (!root) return;
    var exclude = root.getAttribute('data-exclude') || '';
    var items = read()
      .filter(function (item) {
        return item && item.handle && item.handle !== exclude;
      })
      .slice(0, SHOW);

    if (!items.length) {
      root.hidden = true;
      root.innerHTML = '';
      return;
    }

    var heading = root.getAttribute('data-heading') || 'Recently viewed';
    var html = '';
    html += '<div class="egj-recent__inner page-width">';
    html += '<div class="egj-recent__head">';
    html += '<div class="egj-recent__titles">';
    html += '<p class="egj-recent__eyebrow">Keep exploring</p>';
    html += '<h2 class="egj-recent__heading" id="egj-recent-heading">' + escapeHtml(heading) + '</h2>';
    html += '</div>';
    html += '<div class="egj-recent__controls">';
    html +=
      '<button type="button" class="egj-recent__nav egj-recent__nav--prev" data-egj-recent-prev aria-label="Previous products">';
    html +=
      '<svg viewBox="0 0 20 20" width="18" height="18" aria-hidden="true" focusable="false"><path d="M12.5 4.5L7 10l5.5 5.5" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    html += '</button>';
    html +=
      '<button type="button" class="egj-recent__nav egj-recent__nav--next" data-egj-recent-next aria-label="Next products">';
    html +=
      '<svg viewBox="0 0 20 20" width="18" height="18" aria-hidden="true" focusable="false"><path d="M7.5 4.5L13 10l-5.5 5.5" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    html += '</button>';
    html += '</div></div>';

    html += '<div class="egj-recent__viewport">';
    html +=
      '<ul class="egj-recent__list" data-egj-recent-track role="list" aria-labelledby="egj-recent-heading" tabindex="0">';
    items.forEach(function (item, index) {
      var href = safeUrl(item.url);
      if (!href) return;
      var image = safeImageUrl(item.image);
      html += '<li class="egj-recent__item" style="--egj-i:' + index + '">';
      html += '<a class="egj-recent__link" href="' + escapeAttr(href) + '">';
      html += '<span class="egj-recent__media">';
      if (image) {
        html +=
          '<img src="' +
          escapeAttr(image) +
          '" alt="" width="640" height="640" loading="lazy" decoding="async">';
      }
      html += '</span>';
      html += '<span class="egj-recent__copy">';
      html += '<span class="egj-recent__title">' + escapeHtml(item.title) + '</span>';
      if (item.price) {
        html += '<span class="egj-recent__price">';
        if (item.compare) {
          html += '<s>' + escapeHtml(item.compare) + '</s>';
        }
        html += '<span class="egj-recent__price-now">' + escapeHtml(item.price) + '</span>';
        html += '</span>';
      }
      html += '</span></a></li>';
    });
    html += '</ul>';
    html += '<div class="egj-recent__fade egj-recent__fade--start" aria-hidden="true"></div>';
    html += '<div class="egj-recent__fade egj-recent__fade--end" aria-hidden="true"></div>';
    html += '</div>';

    html += '<div class="egj-recent__footer">';
    html += '<div class="egj-recent__progress" aria-hidden="true"><span data-egj-recent-progress></span></div>';
    html += '<div class="egj-recent__dots" role="tablist" aria-label="Recently viewed slides">';
    items.forEach(function (_item, index) {
      html +=
        '<button type="button" class="egj-recent__dot" data-egj-recent-dot="' +
        index +
        '" aria-label="Go to product ' +
        (index + 1) +
        '"></button>';
    });
    html += '</div></div>';

    html += '</div>';
    root.innerHTML = html;
    root.hidden = false;
    bindSlider(root);
    if (window.fpMotion && typeof window.fpMotion.refresh === 'function') {
      window.fpMotion.refresh(root);
    }
  }

  function init() {
    var record = document.querySelector('[data-egj-recent-record]');
    if (record) {
      try {
        remember(JSON.parse(record.textContent));
      } catch (e) {}
    }

    document.querySelectorAll('[data-egj-recently-viewed]').forEach(render);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function () {
    document.querySelectorAll('[data-egj-recently-viewed]').forEach(render);
  });
})();
